// HARDEN phase 2 (Item 5): a single build identifier, inlined at build time into
// BOTH the client bundle and the server (the /api/build-id route). After a new
// deploy, an old tab holds the old constant while the new deploy's route returns
// the new one; the mismatch is how VersionWatcher knows a deploy happened and
// prompts a reload - without a service worker.
//
// NEXT_PUBLIC_BUILD_ID is set in next.config.js from the Netlify deploy
// metadata (COMMIT_REF / DEPLOY_ID), falling back to "dev" locally. It is not in
// REQUIRED_PUBLIC_ENV because next.config always provides a value.
export const BUILD_ID = process.env.NEXT_PUBLIC_BUILD_ID ?? "dev";
